export default __webpack_public_path__ + "img/placeholder.asset.c3139877.jpg";